import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_PART_TYPE, SUMMARY_BY_PART_TYPE } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByPartTypePage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByPartTypeQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Part Type" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Part Type</h1>
      <OrdersCategoryList
        categoryTitle="part_type"
        columns={SUMMARY_BY_PART_TYPE}
        unit="part type(s)"
        resizeStorageKey="orders-by-part-type"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders for ${row.category}`}
            columns={DRILLDOWN_BY_PART_TYPE}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            partType={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByPartTypePage;
